export default "__VITE_ASSET__CS8eV9nW__"